import { COLOR_WHITE, COLOR_TRANSPARENT } from '../../colors'
import type { TTheme } from '../../types'

export const defaultTheme: TTheme = {
  navigationSidebarBackgroundColor: 0x2e2d2cff,
  navigationSidebarActiveItemBackgroundColor: 0x45423fff,
  navigationSidebarActiveItemColor: COLOR_WHITE,
  navigationSidebarItemBackgroundColor: 0x252424ff,
  navigationSidebarItemColor: 0x969390ff,
  navigationSidebarPressedItemBackgroundColor: 0x2e2d2dff,
  navigationSidebarPressedItemColor: 0xa19e9cff,
  navigationSidebarFocusedItemBackgroundColor: 0x2e2d2cff,
  navigationSidebarFocusedItemColor: 0x969390ff,
  navigationSidebarHoveredItemBackgroundColor: 0x383737ff,
  navigationSidebarHoveredItemColor: 0xa6a4a2ff,

  searchFieldBackgroundColor: 0x45423fff,
  searchFieldPlaceholderColor: 0xb5b0aaff,
  searchFieldColor: COLOR_WHITE,
  searchFieldClearIconColor: 0xabaaa9ff,
  searchFieldClearIconHoveredColor: 0xdfdad7ff,
  searchFieldClearIconPressedColor: 0xa19f9dff,
  searchFieldClearIconFocusedBorderColor: 0x979493ff,
  searchFieldSearchIconColor: 0x969391ff,
  searchFieldSearchIconActiveColor: COLOR_WHITE,

  controlsColor: COLOR_WHITE,
  controlsPlaceholderColor: 0x99938dff,
  controlsIconColor: COLOR_WHITE,
  controlsActionColor: COLOR_WHITE,

  popoverBackgroundColor: 0x2e2d2cff,

  tabsColor: 0x99938dff,
  tabsActiveColor: COLOR_WHITE,
  tabsActiveBorderColor: COLOR_WHITE,
  tabsBorderColor: 0x615d59ff,
  tabsDisabledColor: 0x99938d99,
  tabsCloseIconColor: COLOR_WHITE,

  fieldColor: COLOR_WHITE,
  fieldPlaceholderColor: 0x99938dff,
  fieldBorderColor: 0x857f7aff,
  fieldFocusedBorderColor: COLOR_WHITE,

  dropdownColor: COLOR_WHITE,
  dropdownChevronColor: COLOR_WHITE,
  dropdownFocusedBorderColor: COLOR_WHITE,

  demoAreaBackgroundColor: 0x212020ff,

  controlsSidebarBackgroundColor: 0x212020ff,
  controlsSidebarHoveredBackgroundColor: 0x383737ff,
  controlsSidebarPressedBackgroundColor: 0x2e2d2dff,
  controlsSidebarColor: COLOR_WHITE,
  controlsSidebarIconBackgroundColor: 0x424140ff,
  controlsSidebarIconColor: COLOR_WHITE,

  toolbarBackgroundColor: 0x212020ff,
  toolbarIconColor: COLOR_WHITE,
  toolbarIconHoveredColor: COLOR_WHITE,
  toolbarIconPressedColor: COLOR_WHITE,
  toolbarIconActiveColor: 0xa3665fff,
  toolbarIconActiveHoveredColor: 0xa3665fff,
  toolbarIconActivePressedColor: 0xa3665fff,
  toolbarIconFocusedBorderColor: COLOR_WHITE,
  toolbarIconActiveFocusedBorderColor: 0xa3665fff,
  toolbarTextColor: COLOR_WHITE,

  tooltipBackgroundColor: COLOR_WHITE,
  tooltipColor: 0x121110ff,

  sourceCodeBaseWordColor: 0x99938dff,
  sourceCodeOperatorColor: 0xffffffff,
  sourceCodeHtmlSyntaxColor: 0xa0a7d2ff,
  sourceCodeTagNameColor: 0xe9b17eff,
  sourceCodeAttributeColor: 0xf2cf63ff,
  sourceCodeKeywordColor: 0xffbfb7ff,
  sourceCodeStringColor: 0xcbd2f3ff,
  sourceCodeNumberColor: 0xbf8b78ff,
  sourceCodeBooleanColor: 0xea897eff,
  sourceCodeCommentColor: 0xbfbfbfff,
  sourceCodeFunctionCallColor: 0xe7cea4ff,

  sourceCodeLineColor: 0x98928cff,
  sourceCodeActiveLineColor: COLOR_WHITE,
  sourceCodeLineBackgroundColor: 0x212020ff,
  sourceCodeActiveLineBackgroundColor: 0x2e2d2cff,
  sourceCodeHoveredLineBackgroundColor: 0x2e2d2cff,
  sourceCodeActiveHoveredLineBackgroundColor: 0x2e2d2cff,
  sourceCodePressedLineBackgroundColor: 0x2e2d2cff,
  sourceCodeActivePressedLineBackgroundColor: 0x2e2d2cff,
  sourceCodeCollapseIconColor: 0x787471ff,
  sourceCodeCollapseIconHoveredColor: 0x787471ff,
  sourceCodeCollapseIconPressedColor: 0x787471ff,
  sourceCodeCollapseIconFocusedBorderColor: 0x787471ff,

  linkColor: 0xc98179ff,

  switchBackgroundColor: 0x787573ff,
  switchActiveBackgroundColor: 0xa3665fff,
  switchKnobBackgroundColor: COLOR_WHITE,
  switchFocusedBorderColor: 0x787573ff,
  switchActiveFocusedBorderColor: 0xa3665fff,

  checkmarkBackgroundColor: COLOR_TRANSPARENT,
  checkmarkActiveBackgroundColor: 0xa3665fff,
  checkmarkDisabledBackgroundColor: COLOR_TRANSPARENT,
  checkmarkActiveDisabledBackgroundColor: 0x857f7aff,
  checkmarkBorderColor: 0x857f7aff,
  checkmarkActiveBorderColor: 0xa3665fff,
  checkmarkDisabledBorderColor: 0x857f7aff,
  checkmarkActiveDisabledBorderColor: 0x857f7aff,
  checkmarkIconColor: COLOR_WHITE,

  notificationBackgroundColor: 0x615d59ff,
  notificationColor: COLOR_WHITE,
  notificationCloseColor: COLOR_WHITE,

  alertBackgroundColor: 0x615d59ff,
  alertColor: COLOR_WHITE,
  alertIconColor: COLOR_WHITE,
  alertCloseColor: COLOR_WHITE,

  inspectBackgroundColor: 0x9d73b699,

  sandboxBorderColor: 0x45423fff,
  sandboxBorderHoveredColor: 0x857f7aff,
  sandboxBorderPressedColor: 0x615d59ff,

  mdBlockquoteBorderColor: 0x615d59ff,
  mdTableBorderColor: 0x615d59ff,
  mdCodeBackgroundColor: 0x45423fff,
  mdCodeColor: COLOR_WHITE,
  mdCodespanColor: COLOR_WHITE,
  mdHrColor: 0x615d59ff,
}
